import { isCheckoutV2Eligible } from "../../checkout-v2/domain/featureFlags";
import { isBrowsingFulfillmentContextResolved, normalizeFulfillmentContext } from "../../checkout-v2/domain/fulfillmentContext";
import { checkoutV2Api } from "../../checkout-v2/api";
import { buildCheckoutLines } from "../../checkout-v2/domain/cartContext";

export async function validateReorderProducts(products, props) {
  if (!products.length) return false;
  if (!isCheckoutV2Eligible(props.settings)) return true;
  const context = normalizeFulfillmentContext(props);
  const result = await checkoutV2Api.validateCartContext({ context,
    lines: buildCheckoutLines({ cart: products, promo_items: [] }) });
  if (!result.success) throw new Error("Could not validate reorder");
  // Keep the existing cart intact if the historical order cannot be recreated.
  return !result.removedLines.length && !result.adjustedLines.length &&
    result.retainedLines.length === products.length;
}

export function reorderNeedsContext(settings = {}, address = {}, branch = {}) {
  if (!isCheckoutV2Eligible(settings) || settings.only_booking ||
    (settings.enable_delivery === false && settings.enable_pickup === false) ||
    settings.enable_table_qr || settings.enable_car_qr || address?.token || address?.parkingNumber ||
    address?.dineInOrderID || address?.dineInSessionID) return false;
  const context = normalizeFulfillmentContext({ settings, address, branch });
  return !isBrowsingFulfillmentContextResolved(context) || (context.type === "delivery" && !context.areaId);
}

// Never use a product cached for the previously selected branch to reorder.
export function freshReorderProduct(item) {
  const product = item.parent_id ? item.product?.children?.find(child => String(child.id) === String(item.product_id)) : item.product;
  const unavailable = value => !value || value.available === false ||
    value.is_available === false || value.enabled === false ||
    value.is_active === false || value.is_deleted === true || value.not_available === true ||
    value.hide_buy_button === true;
  if (unavailable(item.product) || unavailable(product)) return null;
  return product;
}

export function reorderCheckoutPath(settings) {
  // The canonical shell chooses the first incomplete section (contact, address,
  // extras, then payment). The confirmation alias forces payment prematurely.
  return isCheckoutV2Eligible(settings) ? "/checkout" : "/checkout/details";
}
